/**
 * Local Segment helpers that Opinionate schemas leave open.
 * Event property shapes live in `../generated` — do not duplicate them here.
 */
export namespace Shibuya {
  export enum EventName {
    SKU_VIEWED = 'SKU Viewed',
    SHOPPING_FINISHED = 'Shopping Finished',
  }

  /** Local narrow of Shopping Finished `finish_type` (schema is plain string). */
  export type FinishType = 'external_application' | 'internal_content' | 'lead_inputflow';
}
